var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPointer = function SvgPointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.97 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.48 0C11.41 0 0 11.41 0 25.48S25.48 64 25.48 64s25.48-24.44 25.48-38.52S39.56 0 25.48 0M37.9 38.66c-3.31 3.38-7.73 5.24-12.46 5.24s-9.15-1.86-12.46-5.24a1.5 1.5 0 0 1 2.14-2.1c2.74 2.8 6.4 4.34 10.32 4.34s7.58-1.54 10.32-4.34a1.5 1.5 0 0 1 2.14 2.1"
  })));
};
export default SvgPointer;